import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "waybills-table-column-courier" }
const _hoisted_2 = {
  key: 0,
  class: "waybills-table-column-courier__name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.courier)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.courier.fullName), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" — ")
        ], 64))
  ]))
}